import { AgResourceLanguage } from '../types';
import { sharedComponents as EnUsSharedComponents } from '../en-us/sharedComponents';

export const sharedComponents: AgResourceLanguage['sharedComponents'] = {
  ...EnUsSharedComponents,
  outOfStock: 'Rupture de stock',
  comingSoon: 'Bientôt Disponible',
  button: {
    cancel: 'Annuler',
    delete: 'Supprimer',
    remove: 'Supprimer'
  },
  supportCard: {
    title: 'Besoin d’aide avec votre commande ?',
    description: 'Pour plus d’informations',
    linkFAQ: 'visitez la page FAQ',
    email: 'support@athleticgreens.com',
    phone: '1-888-390-4029',
    phoneHref: '+18883904029'
  },
  paymentInfoBackGuarantee: {
    label: 'Garantie satisfait ou remboursé de 90 jours',
    description: 'Si vous n’aimez pas votre AG1 dans les 90 premiers jours, c’est pour nous.'
  },
  paymentInfoCancelAnytime: {
    label: 'Pause, modification ou annulation à tout moment',
    description: 'Ajustez votre abonnement si vos besoins changent. Vous avez le contrôle.'
  },
  promoCode: {
    promoButtonLabel: 'Appliquer',
    promoCTA: 'Avez-vous un code promo ?',
    promoError: 'Le code promo est invalide',
    promoInputLabel: 'Code promo'
  },
  summaryCheckout: {
    freePrice: 'Gratuit',
    discountLabel: 'Votre réduction',
    totalLabel: 'Total',
    taxLabel: 'Taxe',
    taxNotReady: '---',
    shippingLabel: 'Expédition',
    subtotalLabel: 'Sous-total',
    taxEstimatedLabel: 'Taxe estimée',
    shippingExpectedPrice: 'Gratuit'
  },
  addressForm: {
    firstName: 'Prénom*',
    lastName: 'Nom de famille*',
    country: 'Pays/région*',
    addressLine1: 'Adresse',
    addressLine2: 'Appartement, Suite, Etc',
    city: 'Ville',
    province: 'Province',
    zipCode: 'Code postal',
    phone: 'Téléphone',
    company: 'Entreprise',
    optional: 'facultatif'
  },
  // MODAL CONTENT
  editShippingAddress: {
    headerEdit: 'Modifier l’adresse de livraison',
    headerCreate: 'Créer une adresse de livraison',
    headerSelect: 'Sélectionnez une adresse de livraison',
    reloadMessage: 'Veuillez recharger la page',
    titleEditAddress: 'Informations sur l’adresse',
    usedSavedLabel: 'Utiliser l’adresse enregistrée',
    useSavedAddressText: 'Choisissez l’adresse de livraison pour votre commande.',
    noSavedAddressText: "Vous n'avez actuellement aucune adresse enregistrée",
    useSavedAddressButton: 'Utiliser l’adresse enregistrée',
    noSavedAddressButton: 'Pas d’adresse enregistrée',
    defaultAddress: 'Adresse par défaut :',
    defaultAddressText: 'Cette adresse est utilisée pour votre abonnement.',
    otherAddresses: 'Adresses supplémentaires',
    cancelEditButton: 'Annuler',
    updateEditButton: 'Mettre à jour',
    saveButton: 'Enregistrer',
    cancelSelectButton: 'Annuler',
    updateSelectButton: 'Utiliser l’adresse sélectionnée',
    submitSelectButton: 'Ok',
    massUpdate: 'Utiliser pour tous les abonnements actifs',
    subscriptionUpdate: 'Définir comme adresse de livraison pour mon abonnement',
    giftTitle: 'Envoyer en tant que cadeau',
    giftRecipientEmailLabel: 'E-mail du destinataire*',
    giftMessageLabel: 'Message cadeau',
    giftAddressClosingAlert: {
      title: 'Fermer l’adresse de livraison du cadeau',
      content:
        'Êtes-vous sûr de vouloir fermer l’adresse de livraison sans mise à jour ? Votre cadeau sera envoyé à votre adresse par défaut.',
      editAddressButton: 'Modifier l’adresse',
      confirmButton: 'Confirmer'
    }
  },
  acceptDeleteAddress: {
    titleHeader: 'Supprimer l’adresse',
    description: 'Êtes-vous sûr de vouloir supprimer l’adresse enregistrée ?',
    cancelButton: 'Annuler',
    deleteButton: 'Supprimer'
  },
  addressVerified: {
    title: 'Confirmez votre adresse',
    text: "Nous n'avons pas pu vérifier exactement l'adresse que vous avez saisie. Veuillez vérifier si elle est correcte ou apporter les modifications nécessaires.",
    suggested: 'Adresse suggérée',
    entered: 'Adresse saisie',
    edit: 'Modifier l’adresse',
    continue: 'Enregistrer et continuer'
  },
  giftLabel: {
    short: 'Cadeau',
    long: 'Votre cadeau'
  },
  v53: {
    originalFlavorTitle: 'Original',
    upgradedFormulaText: 'FORMULE AMÉLIORÉE',
    preferredFlavorText: 'MEMBER PREFERRED FLAVOR',
    selectFlavorText: 'Choisir le Goût',
    discardChanges: {
      title: 'Unsaved Changes',
      text: 'Do want to save the changes you made to your subscription?',
      save: 'Save Changes',
      discard: 'Discard Changes'
    }
  }
};
